import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import SiteVisitDetails from "./view";
import {siteVisitById } from 'services/redux/networkEngineer/action';

const mapStateToProps = (state) => ({
    siteVisitByIdDetails: state.NetEnggReducer.siteVisitByIdDetails,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            siteVisitById,
        },
        dispatch
    );


export default connect(mapStateToProps, mapDispatchToProps)(SiteVisitDetails);